import * as routeNames from '../../../../routes/routeName';
import { getBreadcrumbRoutes } from '../../../../components/common/breadCrumbs';

const BASE_LABEL_OVERRIDES = {
	[routeNames.HOME_ROUTE]: 'Home',
	[routeNames.DASHBOARD_ROUTE]: 'Dashboard',
	[routeNames.SUCCESSFULL_ROUTE]: 'Thank You',
	[routeNames.CHAT_NOW]: 'Chat Now',
	[routeNames.pharmacy_sms_tabs]: 'SMS',
	[routeNames.pharmacy_task_management]: 'Task Management',
	[routeNames.pharmacy_create_certificate]: 'Create Certificate',
	[routeNames.pharmacy_edit_certificate]: 'Edit Certificate',
	[routeNames.pharmacy_Team_Notes]: 'Team Notes',
	[routeNames.PHARMACY_WORK_SPACE]: 'Workspace',
	[routeNames.PHARMACY_PRINT_OAT_LOG]: 'Print OAT Log',
	[routeNames.pharmacy_compound_price_list]: 'Compound Price List',
	[routeNames.pharmacy_frequent_dispensing_authorization_timeline]: 'Frequent Dispensing Authorization List',
	[routeNames.pharmacy_view_order_details]: 'Order Details',
	[routeNames.pharmacy_dwi]: 'DWI Patient Data'
};

const EXCLUDED_ROUTES = new Set([
	routeNames.pharmacy_accountability,
	routeNames.pharmacy_accountability_prep_check
]);

const QUERY_ROUTE_ENTRIES = [
	{ route: `${routeNames.ALL_PATIENTS}?status=1`, label: 'Active Patients' },
	{ route: `${routeNames.ALL_PATIENTS}?status=0`, label: 'Inactive Patients' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=today_missed`, label: 'Prep Check' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=odd_billing`, label: 'Odd Billing' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=prep_but_not_billed`, label: 'Not Billed' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=do_not_bill`, label: 'Do Not Bill' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=wrong_prep`, label: 'Wrong Prep' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=billed_but_not_prepared`, label: 'Prep Pending' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=change_dose`, label: 'Changing Dose' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=team_3x4x`, label: 'Missed 3x/4x' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=emergency`, label: 'Emergency Supply' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=flexi_deliver`, label: 'Flexi Deliver' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=patient_drug_information_sheet`, label: 'New Rx' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=ru_re_rr`, label: 'RU/RR/RE/RC' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=fax_due`, label: 'Fax Due' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=drug`, label: 'Drug' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=upload_pics`, label: 'Upload Pics' },
	{ route: `${routeNames.pharmacy_accountability_today_missed_rx}?active=witness_carry`, label: 'Witness/Carry RX' },
	{ route: `${routeNames.pharmacy_ongoing_prescritiptions}?active=uploaded_prescriptions`, label: 'Uploaded Prescriptions' },
	{ route: `${routeNames.pharmacy_ongoing_prescritiptions}?active=uploaded_triplicates`, label: 'Uploaded Triplicates' },
	{ route: `${routeNames.pharmacy_archived_deliveries}?active=deliveries`, label: 'Deliveries' },
	{ route: `${routeNames.pharmacy_archived_deliveries}?active=copay`, label: 'Copay' },
	{ route: `${routeNames.pharmacy_archived_deliveries}?active=flexi_deliver`, label: 'Flexi' },
	{ route: `${routeNames.pharmacy_archived_deliveries}?active=rx_signatures_requested`, label: 'Signatures Requested' },
	{ route: `${routeNames.pharmacy_archived_deliveries}?active=searchrxsheet`, label: 'Log Sheet' },
	{ route: `${routeNames.pharmacy_pharmacist_signature_updation}?active=add_signatures`, label: 'Add Signatures' },
	{ route: `${routeNames.pharmacy_pharmacist_signature_updation}?active=view_signatures`, label: 'View Signatures' },
	{ route: `${routeNames.pharmacy_break_parroll_settings}?active=break_in_out`, label: 'Break In Out Logs' },
	{ route: `${routeNames.pharmacy_break_parroll_settings}?active=payroll`, label: 'Payroll Setting' },
	{ route: `${routeNames.pharmacy_break_parroll_settings}?active=pharmacy_time`, label: 'Schedule Enforcement Settings' },
	// Temporarily inactive
	// { route: `${routeNames.pharmacy_settings}?active=winrx_settings`, label: 'Winrx' },
	// { route: `${routeNames.pharmacy_settings}?active=fax_settings`, label: 'Fax' },
	// Temporarily inactive
	// { route: `${routeNames.pharmacy_settings}?active=delivery_settings`, label: 'Delivery Time' },
	// Temporarily inactive
	// { route: `${routeNames.pharmacy_settings}?active=default_pharmacist_settings`, label: 'Default Pharmacist' },
	{ route: `${routeNames.pharmacy_settings}?active=mistmatch_delivery`, label: 'Mismatch Delivery Mail' },
	{ route: `${routeNames.pharmacy_settings}?active=delivery_access_code`, label: 'Delivery Access Code Mail' },
	{ route: `${routeNames.pharmacy_settings}?active=accountability_settings`, label: 'Accountability' },
	{ route: `${routeNames.pharmacy_settings}?active=witness_carry_setting`, label: 'Witness Carry' },
	{ route: `${routeNames.pharmacy_settings}?active=app_settings`, label: 'App Notification FCM Token' },
	{ route: `${routeNames.pharmacy_sms_tabs}?active=text-messages`, label: 'Text Messages' },
	{ route: `${routeNames.pharmacy_sms_tabs}?active=preset_messages`, label: 'Preset Messages' },
	{ route: `${routeNames.pharmacy_task_management}?active=create_issue`, label: 'Create Task' },
	{ route: `${routeNames.pharmacy_task_management}?active=issues_assigned`, label: 'Task Assigned' },
	{ route: `${routeNames.pharmacy_task_management}?active=tasks_pending`, label: 'Task Pending' },
	{ route: `${routeNames.pharmacy_task_management}?active=tasks_overdue`, label: 'Task Overdue' },
	{ route: `${routeNames.pharmacy_task_management}?active=tasks_completed`, label: 'Task Completed' }
];

const SPECIAL_WORDS = {
	arv: 'ARV',
	erx: 'ERx',
	fda: 'FDA',
	oat: 'OAT',
	oatrx: 'OATRX',
	phn: 'PHN',
	rx: 'RX',
	sms: 'SMS',
	tb: 'TB',
	dwi: 'DWI',
	juno: 'Juno',
	pdf: 'PDF'
};

const normalizeSearchValue = (value = '') =>
	value
		.toLowerCase()
		.replace(/[/?=&_-]+/g, ' ')
		.replace(/\s+/g, ' ')
		.trim();

const formatFallbackLabel = (routeKey) => {
	const cleanedKey = routeKey
		.replace(/^pharmacy_/i, '')
		.replace(/^PHARMACY_/i, '')
		.replace(/_ROUTE$/i, '')
		.replace(/_FORM$/i, ' form');

	return cleanedKey
		.split('_')
		.filter(Boolean)
		.map((word) => {
			const loweredWord = word.toLowerCase();
			if (SPECIAL_WORDS[loweredWord]) return SPECIAL_WORDS[loweredWord];
			return loweredWord.charAt(0).toUpperCase() + loweredWord.slice(1);
		})
		.join(' ');
};

const buildSearchText = (label, route) =>
	normalizeSearchValue(`${label} ${route} ${route.replace(/[/?=&_-]+/g, ' ')}`);

export const getDailyRoutineRouteOptions = () => {
	const breadcrumbRoutes = getBreadcrumbRoutes({ activeTab: '', search: '' });
	const breadcrumbLabelsByRoute = Object.entries(breadcrumbRoutes).reduce((accumulator, [route, details]) => {
		if (details?.label) {
			accumulator[route] = details.label;
		}
		return accumulator;
	}, {});

	const routeEntries = Object.entries(routeNames)
		.filter(([, route]) => (
			typeof route === 'string' &&
			route.startsWith('/') &&
			!EXCLUDED_ROUTES.has(route)
		))
		.map(([routeKey, route]) => ({
			route,
			label:
				breadcrumbLabelsByRoute[route] ||
				BASE_LABEL_OVERRIDES[route] ||
				formatFallbackLabel(routeKey)
		}));

	const mergedEntries = [...routeEntries, ...QUERY_ROUTE_ENTRIES];
	const uniqueEntries = [];
	const seenRoutes = new Set();

	mergedEntries.forEach((entry) => {
		if (!entry?.route || seenRoutes.has(entry.route)) return;
		seenRoutes.add(entry.route);
		uniqueEntries.push({
			label: entry.label,
			route: entry.route,
			searchText: buildSearchText(entry.label, entry.route)
		});
	});

	return uniqueEntries.sort((left, right) => left.label.localeCompare(right.label));
};

export const normalizeDailyRoutineSearch = normalizeSearchValue;
